import React from 'react'
import { checkTextTranslation, checkTranslation, priceStandardView, translate } from '../../utils/useful'
import HttpServices from '../../utils/Http.services'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class RecieveFullAmountInput extends React.Component {
    state = {
        // fullAmount: 10
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            if (value == '') {
                value = null
            }
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
        this.init()
    }

    componentDidUpdate(prevProps, prevState) {

        let triggerKey = this.props.header?.information?.triggerKey
        let targetKey = this.props.header?.information?.targetKey

        if ((prevProps.fullData ? prevProps.fullData[triggerKey] : null) != (this.props.fullData ? this.props.fullData[triggerKey] : null)) {

            this.fetchDocuments()

        }

        if ((prevProps.fullData ? prevProps.fullData[targetKey] : null) != (this.props.fullData ? this.props.fullData[targetKey] : null)) {


            this.receiveFullAmount.checked = (this.props.fullData[targetKey] == this.state.fullAmount)

            // this.fetchDocuments()

        }
    }


    init = () => {

        this.fetchDocuments()

    }


    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }


    changeReceiveFullAmount = (e) => {
        let checked = e.target.checked
        // console.log(checked)
        // let payment = { ...this.state.payment }
        // if (!payment) {
        //     payment = {}
        // }
        let amount = 0

        if (checked) {
            amount = Number(this.state.fullAmount)
        } else {
            amount = 0
        }

        let targetKey = this.props.header?.information?.targetKey

        this.props.changeValue(targetKey, amount, this.props.extra)


        // this.setState({}, () => {
        //     this.amountChanged(payment.amount, !checked)
        // })
    }





    fetchDocuments = () => {

        // console.log("fetchDocuments")

        this.setState({ isLoading: true, fullAmount: null, invoices: [], paymentValues: {}, errors: {} })

        let triggerKey = this.props.header?.information?.triggerKey
        let counterparty = this.props.fullData[triggerKey]
        let type = this.props.header?.information?.type
        let direction = this.props.header?.information?.direction

        // console.log("type", type)
        if (counterparty && direction) {

            let paymentInvoices = []

            if (this.state.payment?.list) {
                this.state.payment.list.forEach(element => {
                    // console.log(element)
                    // paymentInvoices.push((typeof element.invoice == 'object' ? element.invoice._id : element.invoice))
                    paymentInvoices.push((typeof element.document == 'object' ? element.document._id : element.document))

                })
            }


            // console.log("this.props.variables", this.props.variables)

            // let body = {type:'inovice', applet: this.props.variables?.appletId, counterparty, documents: paymentInvoices }
            let body = { direction, appletHub: this.props.variables?.appletHub, counterparty, documents: paymentInvoices }

            // console.log("body", body)
            HttpServices.request("getPendingDocuments", body, (fetchResult, fetchError) => {

                this.setState({ isLoading: false })
                // console.log(fetchResult)
                // console.log(fetchError)

                if (fetchError) {
                    // console.log("HERE")
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                if (fetchResult.info) {

                    let fullAmount = 0
                    if (Array.isArray(fetchResult.info)) {

                        for (let i = 0; i < fetchResult.info.length; i++) {
                            const invoice = fetchResult.info[i]
                            let invoiceAmount = 0

                            if (paymentInvoices.includes(invoice._id)) {
                                if (this.state.payment?.list) {
                                    this.state.payment.list.forEach(element => {

                                        let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                                        if (id == invoice._id) {
                                            invoiceAmount = element.amount
                                        }
                                    });
                                }

                                invoice.balanceDue = invoice.balanceDue + invoiceAmount
                            }

                            fullAmount = fullAmount + (invoice.balanceDue ?? 0)


                        }

                    }


                    // let invoices = [...fetchResult.info]
                    let paymentValues = {}
                    paymentValues['*'] = 0

                    // if (Array.isArray(this.state.payment?.list)) {

                    //     this.state.payment.list.forEach((element, index) => {
                    //         invoices.forEach(invoice => {
                    //             let id = typeof element.invoice == 'object' ? element.invoice._id : element.invoice
                    //             if (invoice._id == id) {
                    //                 paymentValues[index] = element.amount
                    //                 paymentValues['*'] = paymentValues['*'] + element.amount
                    //                 invoice.payment = element.amount
                    //             }
                    //         })


                    //     })


                    // }


                    this.setState({ paymentValues, fullAmount }, () => {

                    })
                } else {
                    this.setState({ fullAmount: 0, paymentValues: {} }, () => {

                    })
                }

            })
        }


    }




    render() {

        return (
            <div className="w-100 h-100 flexc text-start"  >
                {/* ((this.state.fullAmount != null && this.state.fullAmount != 0) ? "" : 'd-none') */}
                <div className={"flexc  "}>
                    <input ref={el => this.receiveFullAmount = el} onChange={(e) => this.changeReceiveFullAmount(e)} id="fullAmount" name="fullAmount" className="" type='checkbox' />
                    <label for='fullAmount' className="mld-2 text-small" style={{ color: '#007aff', userSelect: 'none' }}>{translate("Receive full amount")} ( {priceStandardView(this.state.fullAmount ?? 0)} )</label>
                </div>
            </div>
        )
    }
}

// export default RecieveFullAmountInput;

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(RecieveFullAmountInput);
